import { useAuth } from '@/modules/context/AuthContext'

interface UseDaycareMailToReturn {
    daycareEmail: string | undefined
    canContactDaycare: boolean
    contactDaycare: (subject?: string, body?: string) => void
}

export function useDaycareMailTo(): UseDaycareMailToReturn {
    const { user } = useAuth()

    const daycareEmail: string | undefined = user?.currentDaycare?.email

    function contactDaycare(subject?: string, body?: string): void {
        if (!daycareEmail) return

        // encodeURIComponent (contrairement à URLSearchParams) encode les espaces en %20 et non en "+",
        // qui n'est pas interprété par certains clients mail comme un espace dans un lien mailto
        const params: string[] = []
        if (subject) params.push(`subject=${encodeURIComponent(subject)}`)
        if (body) params.push(`body=${encodeURIComponent(body)}`)

        const query: string = params.join('&')
        window.location.href = `mailto:${daycareEmail}${query ? `?${query}` : ''}`
    }

    return {
        daycareEmail,
        canContactDaycare: Boolean(daycareEmail),
        contactDaycare
    }
}
